import React, { useCallback, useState, useEffect } from 'react';
import { sendLocalStorageSignal } from 'utils/sesionAndLocalStorageHandlers';
import { useSnackbar } from 'notistack';
import action from '../../components/UI/buttons/NotificationDismissButton';
import { axiosSSO, axiosGu } from 'config';

const AuthContext = React.createContext({
    loginInProgress: false,
    login() {},
    logout() {},
    user: null,
});

export function AuthContextProvider({ children }) {
    const { enqueueSnackbar } = useSnackbar();
    const [isUserDataRequested, setIsUserDataRequested] = useState(false);
    const [user, setUser] = useState(null);

    const loginUser = useCallback(async function (userToSet) {
        setUser(userToSet);
    }, []);

    const getUserData = useCallback(
        async function () {
            try {
                const response = await axiosGu('/auth');
                let { username, roles, id } = response?.data || {};

                if (roles?.length) {
                    const user = { username, roles, id };
                    setUser(user);

                    sendLocalStorageSignal('GreatTelepresence_UserLoggedIn', user);
                }
            } catch (err) {
                const resStatus = err?.response?.status;
                if (resStatus !== 401) {
                    enqueueSnackbar('Error getting user data!', {
                        variant: 'error',
                        action,
                    });
                }
            }
            setIsUserDataRequested(true);
        },
        [enqueueSnackbar]
    );

    function logOutHandler() {
        setUser(null);
        sendLocalStorageSignal('GreatTelepresence_UserLoggedOut');
        axiosSSO.post('/logout');
    }

    useEffect(() => {
        globalThis.MyContextAPI = { logOutHandler };
    }, []);

    const sessionStorageTransferHandler = useCallback(function (e) {
        if (!e.newValue) return;

        if (e.key === 'GreatTelepresence_UserLoggedOut') {
            setUser(null);
        }
    }, []);

    return (
        <AuthContext.Provider
            value={{
                formControlers: {
                    logOutHandler,
                },

                sessionStorageTransferHandler,
                sendLocalStorageSignal,
                user,
                isUserDataRequested,
                getUserData,
                setUser,
                loginUser,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
}

export default AuthContext;
